import { themesStatusAdapter, ThemesStatusState } from './themes-status.entity';
import { createReducer, on, Action } from '@ngrx/store';
import { themesStatusActions } from './themes-status.actions';
import { EntityState } from '@ngrx/entity';
import { ThemeStatus } from './../../../api/models/theme-status.model';
import { LoggingService } from './../../../services/logging.service';

export const initialState: ThemesStatusState = themesStatusAdapter.getInitialState({
    ids: [],
    loaded: false
});

export const themesStatusReducerObj = createReducer(
    initialState,

    on(themesStatusActions.loadThemesStatusSuccess, (state, action) => {
        if (action.themesStatus && action.themesStatus !== null && action.themesStatus.length > 0) {
            return themesStatusAdapter.addAll(action.themesStatus, {
                ...state,
                loaded: action.themesStatus && action.themesStatus !== null ? action.themesStatus.length > 0 : false,
                error: null
            });
        }
        else {
            return {
                ...state,
                loaded: false,
                error: null
            }
        }

    }),

    on(themesStatusActions.loadThemesStatusFail, (state, action) => {

        LoggingService.log(action.error);
        return {
            ...state,
            error: action.error
        }
    }),

    on(themesStatusActions.clear, (state, action) => {
        return themesStatusAdapter.removeAll(state);
    }),
);

export function reducer(state: ThemesStatusState = initialState, action: Action): ThemesStatusState {
    return themesStatusReducerObj(state, action);
}

export const themesStatusSelectors = themesStatusAdapter.getSelectors();
